import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = ({ setLanguage, language }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center w-screen h-screen hero-section">
      {/* <Logo />/ */}
      <div className="mt-8 text-center">
        <div className="font-bold text-[40px] text-white">404</div>
        <p className="!mb-[16px] text-[22px] text-white">{t("page_not_found")}</p>
        <Link
          to="/"
          className="px-6 py-3 rounded-lg text-white transition-colors premium-button"
        >
          {t("back_to_home")}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;